import PropTypes from "prop-types";
import React from "react";
import OOSImage from "web/react/components/oos-image/oos-image";
import OOSProductArea, {
    OOSProductAreaPropType,
} from "web/react/components/oos-product-area/oos-product-area";
import ProductStructuredData from "web/react/components/product-structured-data/product-structured-data";
import { RelatedProductsAreaPropType } from "web/types/related-products";
import styles from "./out-of-stock.css";

function OOSProductPage({ productArea, relatedProductsArea, features }) {
    let galleryRelatedProducts = [];
    let relatedProductSection;

    if (relatedProductsArea && relatedProductsArea.sections.length > 0) {
        relatedProductSection = relatedProductsArea.sections[0];
        galleryRelatedProducts = relatedProductSection.related_products.slice(0, 4);
    }

    const {
        products,
        designer,
        absolute_url: absoluteUrl,
        buy_options: buyOptions,
        sorted_buy_options: allSortedBuyOptions,
        sorted_variants: sortedVariants,
    } = productArea;
    let selectedVariant = sortedVariants[0];
    let product = products[selectedVariant];
    let sortedBuyOptions = allSortedBuyOptions.filter((linkId) =>
        product.link_ids.includes(linkId)
    );
    let buyOption = buyOptions[sortedBuyOptions[0]];

    return (
        <>
            <ProductStructuredData
                product={product}
                designer={designer}
                absoluteUrl={absoluteUrl}
                buyOption={buyOption}
            />
            <section className={styles.wrapper}>
                <div className={styles.details}>
                    {/* TODO: Bring Image gallery into OOSProductArea and ProductArea
                    for consistency */}
                    <div className={styles.image}>
                        <OOSImage product={product} relatedProducts={galleryRelatedProducts} />
                    </div>
                    <OOSProductArea
                        className={styles.area}
                        productArea={productArea}
                        relatedProductsSection={relatedProductSection}
                        features={features}
                        selectedVariant={selectedVariant}
                    />
                </div>
            </section>
        </>
        // The rest of the OOS product page (rails, footer etc) will go here
    );
}

OOSProductPage.propTypes = {
    productArea: OOSProductAreaPropType.isRequired,
    relatedProductsArea: RelatedProductsAreaPropType,
    features: PropTypes.objectOf(PropTypes.bool).isRequired,
};

export default OOSProductPage;
